export const DOCTOR_TABS = [
  { label: "General Information", value: 0, code :'general-info' },
  { label: "Stamp & Signature", value: 1, code :'stamp-sign' },
  { label: "Documents", value: 2, code :'doc' },
  { label: "Availability", value: 3, code :'avail' },
  { label: "Outreach OPD / Location", value: 4, code :'outreached-opd' },
];